import React, { Component } from "react";
import PropTypes from "prop-types";
import { Form, Input, Button } from "antd";

const FormItem = Form.Item;

@Form.create()
export default class Ebrochure extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    onSubmit: PropTypes.func,
    location: PropTypes.string,
    project: PropTypes.string
  };
  static defaultProps = {
    onSubmit: () => null,
    location: "",
    project: ""
  };
  state = {
    submitting: false
  };
  componentDidMount() {
    this.nameInput.focus();
  }
  downloadEbrochure = async () => {
    const { location, project, language } = this.props;
    const result = await fetch(
      `${process.env.REACT_APP_SERVICE}/download_ebrochure`,
      {
        method: "POST",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          websiteKey: "lp",
          location,
          project,
          language
        })
      }
    ).then(async response => {
      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "file.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
    return result;
  };
  submit = async data => {
    const { submitting } = this.state;
    if (submitting) return false;
    this.setState({ submitting: true });
    await this.downloadEbrochure();
    // sendEmail({
    //   ...data,
    //   contactType: "contact"
    // });
    // notification.success({
    //   message: "Contact Success"
    // });
    this.setState({ submitting: false });
    this.props.form.resetFields();
    this.props.onSubmit();
    return true;
  };
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.submit(values);
      }
    });
  };
  render() {
    const { t } = this.props;
    const { getFieldDecorator } = this.props.form;
    const { submitting } = this.state;
    return (
      <div className="request-ebrochure-form">
        <Form
          onSubmit={this.handleSubmit}
          style={{ width: 360, background: "white", padding: "20px 50px 15px" }}
        >
          <p style={{ fontSize: 13, marginBottom: "1em" }}>
            {t("Please provide your name & email address")}
          </p>
          <FormItem>
            {getFieldDecorator("name", {
              rules: [
                {
                  required: true,
                  message: t("This field is required")
                }
              ]
            })(
              <Input
                ref={e => {
                  this.nameInput = e;
                }}
                placeholder={`${t("Name")}*`}
              />
            )}
          </FormItem>
          <FormItem>
            {getFieldDecorator("email", {
              rules: [
                {
                  type: "email",
                  message: t("This email is not valid email address")
                },
                {
                  required: true,
                  message: t("This field is required")
                }
              ]
            })(<Input placeholder={`${t("Email address")}*`} />)}
          </FormItem>
          <FormItem>
            <Button type="primary" htmlType="submit" loading={submitting}>
              {t("Submit")}
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Form/Ebrochure.js